import gql from "graphql-tag";

export const MY_TIMESHEET_CREATE_CLIENT = gql`
  mutation createMySheetClient(
    $name: String!
    $description: String!
    $validFrom: Date
    $validTo: Date
  ) {
    createMySheetClient(
      name: $name
      description: $description
      validFrom: $validFrom
      validTo: $validTo
    ) {
      _id
      name
      description
      color
      validFrom
      validTo
      createdAt
      createdBy
      modifiedAt
      modifiedBy
      isDeleted
    }
  }
`;
